"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiHost = exports.host = void 0;
exports.host = __PROXY_TARGET__
    ? window.document.location.origin // proxied through webpack dev server
    : window.document.location.origin.includes('localhost')
        ? 'http://localhost:44321' // local full-stack dev (backend on 44321)
        : window.document.location.origin;
exports.apiHost = exports.host + '/api';
